import './Spinner.sass';

const Spinner = () => {
    return (
        <div className="loader"></div>
    );
};

export default Spinner;